<template>
  <div class="cardTypeHome">
    <!-- 主要内容 -->
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="showModal">
      新增
    </a-button>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="search">
      查询
    </a-button>
    <a-table 
      :columns="columns" 
      :data-source="data" 
      :loading="loading"
      :pagination="pagination"
      :row-key="(record) => record.id"
      @change="handleTableChange">

      <template slot="operation" slot-scope="text, record">
        <a
          @click="buttonDelete(record)"
        >
          {{ data.length>0? '删除':'' }}
        </a>
      </template>
     
    </a-table>
    
    <!-- 模态框 -->
    <a-modal
      :title="title"
      v-model:visible="visible"
      :confirm-loading="confirmLoading"
      @ok="onSubmit"
      @cancel="resetFields"
      width="800"
      :centered="true"
      :padding="10"

    >
      <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
        
         <a-form-item label="会员卡类型" v-bind="validateInfos.cardTypeName">
          <a-input v-model:value="modelRef.cardTypeName" placeholder=""/>
        </a-form-item>
         
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { storeSetCardType,storeInfoCardType,storeDelCardType } from "@/api/storeApi.js";
import { message } from "ant-design-vue";


const columns = [
    {
    title: "id编号",
    dataIndex: "id",
    key: "1",
    align: "center",
    width:150,
    scopedSlots: { customRender: "id" },
  },
 
   {
    title: "会员卡类型",
    dataIndex: "cardTypeName",
    key: "4",
    align: "center",
    width:150,
    scopedSlots: { customRender: "cardTypeName" },
  },
  
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    key: "3",
    width:150,
    align:"center",
  },

];

export default {
  components: {
  
  },
  data() {
    return {
      data: [],
      loading: false,
      columns,
      visible: false,
      title: "新增",
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      modelRef: {
        id: "",
        cardTypeName: "",
      },
      validateInfos: {
        cardTypeName: "",
        
      },
      confirmLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        
      },
      
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },

    // 查询
    search() {
      this.data = [];
      this.loading = true;
      const objId = sessionStorage.getItem("shopId");
      storeInfoCardType(
        objId
      ).then((res) => {
        this.loading = false;
        if(res.success && res.info.length>0){
          this.data = res.data;  
          message.info(res.info);
        }else{
          message.error("暂无数据");
        }
        console.log('请求成功，返回数据:', res);
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('请求出错: ' + error.message);
      });
    },

    get(){
      this.data = [];
      this.loading = true;
      const objId = sessionStorage.getItem("shopId");
      storeInfoCardType(
        objId
      ).then((res) => {
        this.loading = false;
        if(res.success && res.data){
          this.data = res.data;
        }else{
          message.error('暂无数据');
        }
        console.log('请求成功，返回数据:', res);
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('请求出错: ' + error.message);
      });

    },
    showModal() {
      this.visible = true;
      this.edit = false;
      this.modelRef = {
        id: "",
        cardTypeName: "",
        
      };
    },
    
    handleOk(e) {
      this.confirmLoading = true;
      setTimeout(() => {
        this.visible = false;
        this.confirmLoading = false;
      }, 2000);
    },
    
    onSubmit() {
        this.loading = true;
      //新增
        console.log('新增:', this.modelRef);
        storeSetCardType({
            cardTypeName: this.modelRef.cardTypeName,
            storeId: sessionStorage.getItem("shopId"),
        }).then((res) => {
            this.loading = false;
            if(res.success){
            message.success(res.info);
            
            this.get(); // 重新获取数据确保页面更新
            }else{
            message.error(res.info);
            }
            console.log('请求成功，返回数据:', res);
            this.get();
        }).catch((error) => {
            this.loading = false;
            console.error('请求出错:', error);
            message.error('请求出错: ' + error.message);
        })
      this.visible = false;
    
    },
   
    resetFields() {
      this.modelRef = {
        id: "",
        cardTypeName: "",
        
      };
      
    },
    
    handleTableChange(pagination, filters, sorter) {
      console.log('表格变化:', pagination, filters, sorter);
      // 更新分页信息
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      // 重新获取数据
      this.get();
    },
    
    buttonDelete(record) {
      console.log('删除记录:', record);
      this.$confirm({
        title: "确定要删除吗?",
        content: "当您点击确定按钮后，该记录将被删除",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {  
          this.loading = true;
          storeDelCardType({id:record.id}).then((res) => { 
            this.loading = false;
            if(res.success){
              this.loading = false;
              message.success(res.info);
              this.get();
            }else{
              message.error(res.info);
            }
          }).catch((error) => {
            this.loading = false;
            console.error('请求出错:', error);
            message.error('请求出错: ' + error.message);
          })
        },
        onCancel() {
          console.log("点击了取消");
        }
      })
    },

    
  },
};
</script>

<style scoped>

.cardTypeHome{
  margin: 20px;
}
.test {
  position: relative;
  left: 55px;
}

/* 移除scoped限制以便更好地应用样式 */
</style>

<style>
.cardTypeHome .ant-table-wrapper {
  background: #ffffff;
}

.cardTypeHome .ant-table-thead > tr > th {
  background: #FAFAFA;
}

.cardTypeHome .ant-table-tbody > tr > td {
  background: #ffffff;
}

.cardTypeHome .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: #ffffff;
}

.cardTypeHome .ant-table-tbody > tr.ant-table-row-selected > td {
  background: #ffffff;
}

.cardTypeHome .ant-table-tbody > tr.ant-table-row:hover > td {
  background: #ffffff;
}

#components-table-demo-summary tfoot th,
#components-table-demo-summary tfoot td {
  background: #ffffff;
}
[data-theme='dark'] #components-table-demo-summary tfoot th,
[data-theme='dark'] #components-table-demo-summary tfoot td {
  background: #1d1d1d;
}
</style>


// WEBPACK FOOTER //
// src/views/functionSettings/cardType/cardTypeHome.vue